export const imageUrl = (url) => {
    const imgUrl = `https://backend.vendispot.wise-hustlers.com`

    return imgUrl + url
}

export const formatSlot = (layer, slot) => {
    console.log(layer , slot)
    if (layer == 2 && slot == 10) return 30
    if (layer == 3 && slot == 10) return 40
    if (layer == 4 && slot == 10) return 50
    if (layer == 5 && slot == 10) return 60
    return `${layer}${slot}`
}